import React, { useRef, useEffect } from 'react';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import Contact from 'modules/MainModule/components/Contact/Contact';
import StartNow from 'modules/Shared/components/StartNow/StartNow';
import { colorBackgroundBrightness } from 'data/common.data';
import '../IndustryType.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Airlines = (props: any) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    const headerBg: string = '/images/backgrounds/ALEG-Image-Airlines_Header-.jpg';
    const styleData = { backgroundImage: `linear-gradient(${colorBackgroundBrightness}, ${colorBackgroundBrightness}), url(${headerBg})` };
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>AirLegit Tools for Airlines</title>
                    <meta name='description' content='AI-driven predictive analysis on flight performances and an array of ready-made applications to supplement your current customer experience.' />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='page-min-height industry-type-data-container'>
                <div className='header-container container-side-padding container-content-padding' style={styleData}>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <h1>
                                        Airlines
                                    </h1>
                                    <p className=''>
                                        Partner with AirLegit.
                                    </p>
                                    <p className=''>
                                        We collect millions of data points and would like to have yours. We offer an Al- driven predictive analysis on flight performances and an array of ready- made applications to supplement your current customer experience.
                                    </p>
                                </div>
                                <div className='col-md-6'>
                                    <div className='logo-wrapper' style={{ maxWidth: '350px' }}>
                                        <img src='/images/others/ALEG-Image-Header_DashText.png' alt='airlegit-devices' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='content-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6 order-2 order-md-1'>
                                    <h3 className='text-med'>
                                        AirLegit&#169; for Airlines
                                    </h3>
                                    <p className=''>
                                        Give your customers seamless, confident travel when they book with you.
                                    </p>
                                    <p className='no-margin'>
                                        Offer AirLegit as a value-added service bundled with your bookings and develop additional revenue streams. AirLegit's ready-made solutions offer a relevant supplementary product offering to your customers, while ensuring compliance and delivering on the high-level of customer expectations. In addition AirLegit's automated solutions may alleviate your customer support teams time and effort by automating flight disruption events.
                                    </p>
                                </div>
                                <div className='col-md-6 order-1 order-md-2'>
                                    <div className='bordered-img-wrapper'>
                                        <img src='/images/others/ALEG-Image-Body-Airlines.jpg' alt='frame' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <StartNow />
            </div>
            <Contact />
            <Footer />
        </>
    );
};

export default Airlines;